import { FULL_DAY_NAMES } from '../../constants/dates';

export const getWeekSchedule = (startOfWeekIndex = 1, businessHoursData = null) => {
  // If no business hours data is provided, return empty schedule for all days
  if (!businessHoursData || businessHoursData.length === 0) {
    return FULL_DAY_NAMES.map(day => ({
      dayOfWeek: day,
      available: 0,
      publicFrom: null,
      publicTo: null,
      publicSplitFrom: null,
      publicSplitTo: null,
      workdayFrom: null,
      workdayTo: null,
    }));
  }

  const adjustedIndex = startOfWeekIndex;
  const rotatedSchedule = [...businessHoursData.slice(adjustedIndex), ...businessHoursData.slice(0, adjustedIndex)];
  return rotatedSchedule;
};

export const getWeekStartDay = (startOfWeekIndex = 1) => {
  return FULL_DAY_NAMES[startOfWeekIndex];
};

export const convertTimeTo12HourFormat = (time) => {
  if (!time) return '';

  const [hours, minutes] = time.split(':').map(Number);
  if (Number.isNaN(hours) || Number.isNaN(minutes)) return '';

  const period = hours >= 12 ? 'PM' : 'AM';
  const formattedHours = hours % 12 === 0 ? 12 : hours % 12;
  return `${formattedHours}:${minutes.toString().padStart(2, '0')} ${period}`;
};

export const parseAddress = (address) => {
  const addressParts = address ? address.split(', ') : ['', '', ''];
  const [streetAddress, city, stateZip] = addressParts;
  const [state, zipcode] = stateZip ? stateZip.split(' ') : ['', ''];

  return {
    streetAddress,
    city,
    state,
    zipcode,
  };
};
